export default __webpack_public_path__ + "static/media/person.ccaf63de.svg";